var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "tippy",
          rawName: "v-tippy",
          value: _vm.tooltipConfig,
          expression: "tooltipConfig",
        },
      ],
      staticClass: "pivot-cell",
      class: _vm.cellTypeClass,
      style: _vm.cellStyle,
    },
    [
      _c("span", { staticClass: "cell-value" }, [
        _vm._v(_vm._s(_vm.formattedValue)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }